export default "__VITE_ASSET__NScos8qP__"